import { createContext } from "react";
import { useParams } from "react-router-dom";
import useSignFormLogic from "./hooks/useSignFormLogic";
import Loader2 from "../../../../components/Loader2";
import { Col, Container, Row } from "react-bootstrap";
import DocumentHeader from "./components/DocumentHeader";
import FormTemplateSelection from "./components/FormTemplateSelection";
import PdfTemplateDisplay from "./components/PdfTemplateDisplay";

export const SignFormContext = createContext(null)

export default function SignForm() {
    const { id } = useParams();
    const context = useSignFormLogic(id);
    const {
        isLoadingResources,
    } = context ?? {}

    if (!id) return <h1 className="text-danger">Invalid page redirect</h1>

    if (isLoadingResources) return <Loader2 />

    return (
        <SignFormContext.Provider value={context}>
            <Container fluid>
                <DocumentHeader />
                <Row>
                    <Col md="4">
                        <FormTemplateSelection/>
                    </Col>
                    <Col md="8">
                        <PdfTemplateDisplay />
                    </Col>
                </Row>
            </Container>
        </SignFormContext.Provider>
    )
}